import { Badge, cn, Icon, type MaterialSymbol } from "@qw/ui";
import type { ComponentProps } from "react";
import { Link, type To } from "react-router";

export type FolderRowProps = Omit<ComponentProps<typeof Link>, "children" | "to"> & {
  active?: boolean;
  count?: number;
  hasError?: boolean;
  icon: MaterialSymbol;
  text: string;
  to: To;
};

export const FolderRow = ({
  active = false,
  className,
  count,
  hasError = false,
  icon,
  text,
  to,
  ...props
}: FolderRowProps) => (
  <Link
    to={to}
    aria-current={active ? "page" : undefined}
    className={cn(
      "group grid h-8 grid-cols-[--spacing(7)_minmax(0,1fr)_auto] items-center gap-2 rounded-md px-2 text-xs text-muted-foreground transition-colors",
      "hover:bg-foreground/5 hover:text-foreground",
      active && "bg-foreground/7.5 text-foreground",
      className
    )}
    {...props}
  >
    <Icon
      icon={icon}
      className={cn("justify-self-center text-base group-aria-current:text-inherit", active && "filled")}
    />
    <span className="truncate">{text}</span>
    {count || hasError ? (
      <span className="flex items-center gap-1 justify-self-end">
        {count ? (
          <Badge
            variant="secondary"
            size="2xs"
            type="square"
            className="text-muted-foreground group-aria-current:text-foreground"
          >
            {count}
          </Badge>
        ) : null}
        {hasError ? (
          <Icon icon="error" aria-label="Failed scheduled sends" className="size-4 text-base text-destructive filled" />
        ) : null}
      </span>
    ) : null}
  </Link>
);
